export function getFormattedPrice(value: number) {
  if(value % 1 !== 0) {
    return `${value.toFixed(2)} kr`
  } 
  return `${value} kr`
}